exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tbody[data-v-8059d60e]{display:block;height:400px;overflow:auto}tbody tr[data-v-8059d60e],thead[data-v-8059d60e]{display:table;width:100%;table-layout:fixed}thead[data-v-8059d60e]{width:100%}", ""]);

// exports
